module.exports = __webpack_public_path__ + "static/media/logo-light.96788616.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Menu/logo-light.svg
// module id = 595
// module chunks = 0